import HTitle from './HTitle'

HTitle.install = function (Vue) {
  Vue.component(HTitle.name, HTitle)
}

export default HTitle
